import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SMART_CUTOUT_MODE_OPTIONS,
  normalizeSmartCutoutMode,
} from '@/pages/ipe/workbench/constants/imageProcessStudioConfig';
import '@/styles/ipe/workbench/Img2ImgPage.css';

export default function SmartCutoutStepParams({ p = {}, onChange, readOnly = false }) {
  const { t } = useTranslation('workbench');
  const mode = normalizeSmartCutoutMode(p.cutoutMode ?? p.mode);
  const modeLabel = {
    basic: t('workflowParams.cutoutBasic'),
    advanced: t('workflowParams.cutoutAdvanced'),
  };

  return (
    <div className="img2img-page wf-studio-params-root wf-editor-smart-cutout">
      <section className="img2img-studio__section" aria-label={t('workflowParams.cutoutMode')}>
        <div className="img2img-studio__field-row">
          <span className="img2img-studio__field-label">{t('workflowParams.cutoutMode')}</span>
        </div>
        <div className="img2img-studio__qty-row" role="group" aria-label={t('workflowParams.cutoutMode')}>
          {SMART_CUTOUT_MODE_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`img2img-studio__qty-btn${mode === option.value ? ' is-active' : ''}`}
              onClick={() => onChange?.({ cutoutMode: option.value })}
              disabled={readOnly}
              aria-pressed={mode === option.value}
            >
              {modeLabel[option.value] || option.label}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
